module.exports = __webpack_public_path__ + "img/right2.3aaabe0c.png";